import ArrowBack from '@mui/icons-material/ArrowBack';
import Delete from '@mui/icons-material/Delete';
import { Button, CircularProgress, DialogContent, DialogTitle, Typography } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface IButton {
    onClick: () => void;
    label: string;
    loading?: boolean;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
}

interface ICancelContentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title?: string;
    subtitle?: string;
    primary: IButton;
    secondary: IButton;
}

const CancelContent = ({ title, primary, secondary, subtitle, ...props }: ICancelContentProps) => {
    return (
        <div {...props} className={clsx('px-16 pt-24 pb-16', props.className)}>
            <DialogTitle className="flex flex-col justify-center gap-3 text-center h-fit">
                <Typography variant="h4" fontWeight={500} className="font-museo">
                    {title}
                </Typography>
                <Typography variant="body2" fontWeight={400} className="font-inter">
                    {subtitle}
                </Typography>
            </DialogTitle>

            <DialogContent className="mt-10 flex-none">
                <div className="flex justify-center gap-7">
                    <Button
                        className="rounded-full w-full"
                        variant="contained"
                        startIcon={secondary.startIcon ?? <ArrowBack />}
                        endIcon={secondary.endIcon ?? null}
                        disableElevation
                        color="secondary-alt"
                        onClick={secondary.onClick}
                    >
                        <Typography fontWeight={500}>{secondary.label}</Typography>
                    </Button>
                    <Button
                        className="rounded-full w-full"
                        color="error"
                        endIcon={secondary.endIcon ?? null}
                        onClick={primary.onClick}
                        startIcon={primary.loading ? <CircularProgress /> : primary.startIcon ?? <Delete />}
                        disabled={primary.loading}
                    >
                        <Typography fontWeight={500}>{primary.label}</Typography>
                    </Button>
                </div>
            </DialogContent>
        </div>
    );
};

export { CancelContent };
export type { ICancelContentProps };
